/**
 * 自動生成。直接直さない。
 *
 * 一覧など件数だけを使う画面が、つまずき本文の全カタログを
 * クライアントへ読み込まないための小さなメタデータ。
 */
export const MISTAKE_TOTAL = 723;
